<form [formGroup]="uploadForm">
  @if(flow !== 'authorizations') { 
   <div style="width: 100%">
   <nz-form-label nzFor="document_type"
     class="ppl-form-label"> Document Type*
   </nz-form-label>
 </div>
}
   @if(flow !== 'authorizations') {
    <nz-form-item class="ppl-form-item">
        <nz-form-control nz-tooltip nzTooltipPlacement="topRight" class="upload-row-control">
          <div class="upload-row">
            <div class="upload-main">
              <div [ngClass]="{'error': validationErrors['document_type'] }">
                <ppl-dropdown-select formControlName="document_type" id="document_type" pplNzAriaLabel
                nzAriaLabel="Document type" 
                [options]="docTypeList" [optionLabel]="'lkpValueName'"
                [optionValue]="'lkpValueCode'"
                placeholder="Select document type"
                (selectionChange)="docTypeChanged($event)"></ppl-dropdown-select>
              </div>
              @if(uploadForm.get('document_type')?.value === 'OTH'){
              <div class="upload-other-type">
                <div nz-tooltip nzTooltipPlacement="topRight">
                  <input class="type-input" nz-input placeholder="Document Name" formControlName="other_type" />
                </div>
              </div>
              }
              @if (validationErrors['document_type']) {
              <span class="pl-1 error-message">{{validationErrors['document_type']}}</span>
              }
            </div>
            <div class="upload-action">
              <nz-upload (nzChange)="handleChange($event)" [nzDisabled]="!enableUpload && flow !== 'authorizations'" [nzShowUploadList]="false" [nzCustomRequest]="customRequest" [nzAccept]="'.txt, .pdf, .doc, .docx, .xls, .xlsx, .csv, .png, .jpg, .jpeg'">
                <div class="primary-btn" [attr.aria-label]="'Upload Documents'" [ngClass]="{'upload': type === 'authorizations'}">
                  <i class="fa fa-upload onemore" aria-hidden="true"></i>
                  {{buttonText}}
                </div>
              </nz-upload>
            </div>
          </div>
        </nz-form-control>
    </nz-form-item>
  }
  @else {
  <nz-form-item class="ppl-form-item upload-icon">
    <nz-form-control>
      <nz-upload (nzChange)="handleChange($event)" [nzDisabled]="!enableUpload && flow !== 'authorizations'" [nzShowUploadList]="false" [nzCustomRequest]="customRequest" [nzAccept]="'.txt, .pdf, .doc, .docx, .xls, .xlsx, .csv, .png, .jpg, .jpeg'">
        <div class="primary-btn" [attr.aria-label]="'Upload Documents'" [ngClass]="{'upload': type === 'authorizations'}">
          <i class="fa fa-upload onemore" aria-hidden="true"></i>
          {{buttonText}}
        </div>
      </nz-upload>
    </nz-form-control>
  </nz-form-item>
  }
  <!-- } -->
  <!-- @else {
  <nz-form-item class="ppl-form-item">
    <nz-form-control class="ppl-form-control">
      <div nz-tooltip nzTooltipPlacement="topRight">
        <input class="type-input" nz-input placeholder="Document Name" formControlName="document_type" />
      </div>
    </nz-form-control>
  </nz-form-item>
  } -->

</form>
  <div nz-row class="ppl-form-item">
    <p class="info-box">
      <i class="fa fa-info-circle" aria-hidden="true"></i> Allowable file types: txt, pdf, doc, docx, xls, xlsx, csv, png, jpg, jpeg.
    </p>
  </div>
  @if(flow === 'providerEnrollment') {
  <hr class="mt-0 upload-row-control">
  <div class="ppl-form-item upload-row-control">
    <div class="info-box mt-0">
      <i class="fa fa-info-circle" aria-hidden="true"></i>
      <strong>Important Notice: Health Assessment Documentation</strong>
      <br/>
      If you are uploading documents related to your CDPAP Health Assessment, please submit them directly to your health assessment vendor's portal for fastest processing. If you have already submitted your documents through the vendor portal, please do not upload them again here, as duplicate submissions may cause delays.
      <div *ngIf="healthAssessmentVendor && healthAssessmentVendor === 'MH'" class="btn-group mt-3 mb-2 d-flex justify-content-start">
        <br/>
        <a [href]="HEALTH_ASSESSMENT_VENDOR_URLS.MOBILEHEALTH_LANDING_URL + '#PPLUploadDocs'" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">
          <div class="secondary-btn" [attr.aria-label]="'Send Health Assessment Documents'"  >
            <i class="fa fa-upload onemore" aria-hidden="true"></i>
            Send Health Assessment Documents
          </div>
        </a>
      </div>
    </div>
        </div>
  }
  @if(showFileList) {
    <ul class="list-container">
      @for(file of fileDetailsArr; track $index){
      <li class="file-details">
        <span class="text-hidden"><strong>{{file.type}} :</strong></span>
        <span class="text-hidden"><span nz-icon nzType="paper-clip" nzTheme="outline"></span>{{ file.name }}</span>
        <div class="card flex flex-wrap flex-column align-items-center gap-2">
          <div class="flex flex-wrap justify-content-center gap-2">
            <button
              aria-label="Delete"
              nz-button 
              nzType="default" 
              (click)="confirmPosition('top',file)" 
              class="remove-btn"
            >
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </div>
        </div>
      </li>
      }
    </ul>
  }
